import { STATUS_CONTACT } from "./constants";

document.onreadystatechange = function () {
  if (document.readyState !== "complete") {
    document.querySelector("#loader").style.visibility = "visible";
  } else {
    document.querySelector("#loader").style.display = "none";
    if (document.querySelector("#app")) {
      document.querySelector("#app").style.display = "block";
    }
  }
};

window.onpageshow = function (event) {
  if (event.persisted) {
    window.location.reload();
  }
};

export const headers = {
  "Content-Type": "application/json",
  "X-CSRF-TOKEN": document
    .querySelector('meta[name="csrf-token"]')
    .getAttribute("content"),
};

export function convertStatusLabel(statusCode, statusName) {
  if (parseInt(statusCode) === STATUS_CONTACT.solved) {
    return `<span class="status-text-solved">${statusName}</span>`;
  }
  if (parseInt(statusCode) === STATUS_CONTACT.reply_from_admin) {
    return `<span class="status-text-replied">${statusName}</span>`;
  }

  return `<span class="status-text-unsolved">${statusName}</span>`;
}

export function convertStatusLabelPartner(statusCode, statusName) {
  if (parseInt(statusCode) === STATUS_CONTACT.solved) {
    return `<span class="status-text-solved">${statusName}</span>`;
  }
  if (parseInt(statusCode) === STATUS_CONTACT.reply_from_user) {
    return `<span class="status-text-replied">${statusName}</span>`;
  }

  return `<span class="status-text-unsolved">${statusName}</span>`;
}

export function convertContentContactToLink(detail, url) {
  return `<a class="el-link el-link--default link-detail" href="${url}"><span class="el-link__inner">${detail}</span></a>`;
}

export function checkAge(birthday) {
  let dateOfBirth = new Date(birthday).getTime();
  let ageDifMs = Date.now() - dateOfBirth;
  let ageDate = new Date(ageDifMs);
  return Math.abs(ageDate.getUTCFullYear() - 1970);
}

export const Checkurl = (inputText) => {
  var replacedText, replacePattern1, replacePattern2, replacePattern3;

  replacePattern1 =
    /(\b(https?|ftp):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gim;
  replacedText = inputText.replace(
    replacePattern1,
    '<a href="$1" target="_blank">$1</a>'
  );

  replacePattern2 = /(^|[^\/])(www\.[\S]+(\b|$))/gim;
  replacedText = replacedText.replace(
    replacePattern2,
    '$1<a href="http://$2" target="_blank">$2</a>'
  );

  replacePattern3 = /(([a-zA-Z0-9\-\_\.])+@[a-zA-Z\_]+?(\.[a-zA-Z]{2,6})+)/gim;
  replacedText = replacedText.replace(
    replacePattern3,
    '<a href="mailto:$1">$1</a>'
  );

  return replacedText;
};
